import React, { useState } from "react";
import { useSelector } from "react-redux";

const WriteAReview = ({ onReview }) => {
  const [rating, setRating] = useState(0); // Initialize rating to 0
  const [reviewText, setReviewText] = useState("");
  const { carDetails: listingId } = useSelector((state) => state.details); // Listing ID

  const handleRatingClick = (value) => {
    setRating(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    onReview({ listingId: listingId?.id, rating, reviewText });
    setRating(0);
    setReviewText("");
  };

  return (
    <div
      id="review_submit_modal"
      className="hp-modal"
      style={{ display: "inline-block" }}
    >
      <form onSubmit={handleSubmit} className="hp-form hp-form--review-submit">
        <div className="hp-form__fields">
          <input
            type="hidden"
            name="listing"
            value={listingId?.id}
            className="hp-field hp-field--hidden"
          />
          <div className="hp-form__field hp-form__field--rating hp-field-label-rating">
            <label className="hp-field__label hp-form__label">
              <span>Rating</span>
            </label>
            <div className="hp-rating-stars hp-rating-stars--large hp-field hp-field--rating">
              {[1, 2, 3, 4, 5].map((value) => (
                <i
                  key={value}
                  onClick={() => handleRatingClick(value)}
                  className={`fas fa-star ${value <= rating ? "checked" : ""}`}
                  title={value}
                />
              ))}
              <input name="rating" type="hidden" value={rating} />
            </div>
          </div>
          <div className="hp-form__field hp-form__field--textarea hp-field-label-text">
            <label className="hp-field__label hp-form__label">
              <span>Review</span>
            </label>
            <textarea
              name="text"
              maxLength="2048"
              required
              className="hp-field hp-field--textarea"
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
            />
          </div>
        </div>
        <div className="hp-form__footer">
          <button
            type="submit"
            className="hp-form__button button-primary alt button hp-field hp-field--submit"
          >
            <span>Submit Review</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default WriteAReview;
